import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { compose } from 'redux'
import { map, filter, get, head, reduce, isEmpty, groupBy, values } from 'lodash'

import CartItem from './CartItem'
import { formatPrice } from '../utils/formatters'
import {
  removeFromCart,
  safelyIncrementCartItemQuantity,
  safelyDecrementCartItemQuantity,
} from '../../actions/cart';
import Button from '../components/Button'
import {
  getTotal,
  alcoholItemCountSelector,
  getCartItems,
} from '../../selectors/cart'
import { toggleAppState } from '../../actions/appState'
import { getCurrentMenu } from '../../selectors/menus'
import CartItemsViewModel from '../../viewmodels/CartItemsViewModel'

export class Cart extends Component {
  static propTypes = {
    cart: PropTypes.array.isRequired,
    removeFromCart: PropTypes.func.isRequired,
    safelyIncrementCartItemQuantity: PropTypes.func.isRequired,
    safelyDecrementCartItemQuantity: PropTypes.func.isRequired,
    alcoholLimit: PropTypes.number.isRequired,
    history: PropTypes.object.isRequired,
    totalPrice: PropTypes.number.isRequired,
    alcoholItemCount: PropTypes.number.isRequired,
    isAlcoholWarningConfirmed: PropTypes.bool.isRequired,
    toggleAppState: PropTypes.func.isRequired,
    setItemsSummary: PropTypes.func,
    cartItemsSummary: PropTypes.array,
  }

  state = {
    showEmptyCartWarning: false,
  }

  _payNow = () => {
    const { cart, history, setItemsSummary } = this.props

    const itemsWithMinAmount = filter(cart, item => item.orderMinCount !== null)
    const sameItems = map(groupBy(itemsWithMinAmount, 'id'), group => values(group))

    const cartItemsSummary = sameItems.map(items => {
      const sum = reduce(items, (acc, item) => {
        const quantity = get(item, 'quantity')
        return acc + quantity
      }, 0)
      const name = get(head(items), 'name')
      const minAmount = get(head(items), 'orderMinCount')
      const diff = minAmount - sum

      return {
        minAmount,
        name,
        diff
      }
    })

    const cartItemsSummaryWithNotEnoughAmount = cartItemsSummary.filter(item => item.diff > 0)

    if (cart.length > 0 && cartItemsSummaryWithNotEnoughAmount.length === 0) {
      history.push('/kiosk/order/payment')
    } else {
      if (!this.state.showEmptyCartWarning) {
        this.setState({ showEmptyCartWarning: true })
        // make sure the same time value is on .cart__empty CSS animation
        setTimeout(() => this.setState({ showEmptyCartWarning: false }), 8000)
      }
      setItemsSummary(cartItemsSummaryWithNotEnoughAmount)
    }
  }

  handleRemoveFromCart = index => {
    const { removeFromCart } = this.props
    removeFromCart(index)
  }

  render() {
    const {
      cart,
      totalPrice,
      alcoholItemCount,
      removeFromCart,
      alcoholLimit,
      isAlcoholWarningConfirmed,
      toggleAppState,
      safelyIncrementCartItemQuantity,
      safelyDecrementCartItemQuantity,
      onItemClick,
      cartItemsSummary,
      setItemsSummary,
    } = this.props
    const { showEmptyCartWarning } = this.state

    return (
      <div className="cart">
        {!cart.length ? (
          <React.Fragment>
            <Button className="cart__pay btn -primary" onClick={this._payNow} title="Pay now" />
            {showEmptyCartWarning && <div className="cart__empty">Your Cart is Empty</div>}
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Button className="cart__pay btn -primary" onClick={this._payNow} title="Pay now" />
              {!isEmpty(cartItemsSummary) && cartItemsSummary.map((item, index) => (
                <p key={index} className="cart__min-amount-warning">
                  {`${item.name} must meet minimum quantity of ${item.minAmount} to proceed.`}
                </p>
              ))}
            <div className="cart__items">
              {cart.map((cartItem, index) => (
                <CartItem
                  alcoholLimitExceeded={
                    cartItem.isAlcohol
                      ? alcoholItemCount === alcoholLimit && !isAlcoholWarningConfirmed
                      : false
                  }
                  cart={cart}
                  confirmAlcoholWarning={() => toggleAppState({ isAlcoholWarningConfirmed: true })}
                  item={cartItem}
                  key={`${cartItem.id}${index}`}
                  removeFromCart={removeFromCart}
                  setItemsSummary={setItemsSummary}
                  incrementQuantityForItem={safelyIncrementCartItemQuantity}
                  decrementQuantityForItem={safelyDecrementCartItemQuantity}
                  onItemClick={() => onItemClick(cartItem.id, index)}
                  index={index}
                />
              ))}
            </div>
            <div className="cart__row -total">
              Total:
              <div className="cart__price">{formatPrice(totalPrice)}</div>
            </div>
          </React.Fragment>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  cart: CartItemsViewModel(getCartItems(state)),
  alcoholLimit: getCurrentMenu(state).alcoholLimit,
  totalPrice: getTotal(state),
  alcoholItemCount: alcoholItemCountSelector(state),
  isAlcoholWarningConfirmed: state.appState.isAlcoholWarningConfirmed,
})

const mapDispatchToProps = {
  safelyIncrementCartItemQuantity,
  safelyDecrementCartItemQuantity,
  removeFromCart,
  toggleAppState,
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withRouter,
)(Cart)
